import { Button } from "../../components/button.component";
import imageUploadLogo from "../../assets/img/Upload-Photo-patient.svg";
import { Form } from "rsuite";
import { FileInput, TextInput } from "../../components/textInput.component";
import { useState, useEffect } from "react";
import { showSuccessToast } from "../../components/toast.component";
import { UploadedFileType } from "../../models/forms/uploadFileType";
import { ApiUsers } from "../../core/apis/users";
import { generateMultipartFormData } from "../../utils/formUtils";
import { SpinLoader } from "../../components/spinLoader.component";
import { useAppDispatch } from "../../core/redux/ReduxStore";
import { ActionAuth } from "../../core/redux/slices/sliceAuth";
import { AppRouteApi } from "../../config/appRoute";

type SettingsFormData = {
  FirstName?: string;
  LastName?: string;
  PhoneNumber?: string;
  ProfilePic?: UploadedFileType[];
};

export const AccountSettings = ({ expanded }: { expanded?: boolean }) => {
  const [formData, setFormData] = useState<SettingsFormData>();
  const [isDisabled, setIsDisabled] = useState(true);
  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { data, isValidating } = ApiUsers.Profile.Hook();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setFormData({
      FirstName: data?.firstName || "",
      LastName: data?.lastName || "",
      PhoneNumber: data?.phoneNumber || "",
      ProfilePic: [],
    });
  }, [data]);

  const handleChange = (data: any, error: any) => {
    setFormData({ ...formData, ...data });
    const errorCount = Object.keys(formError).length;
    setIsDisabled(!!errorCount);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const multipartFormData = generateMultipartFormData(formData);
    const result = await ApiUsers.ChangeAccountSettings(multipartFormData);
    if (result.isSuccess) {
      showSuccessToast("Profile Updated");
      dispatch(ActionAuth.SetProfilePic(result.data?.profilePic || ""));
      dispatch(ActionAuth.SetFirstName(result.data?.firstName || ""));
      dispatch(ActionAuth.SetLastName(result.data?.lastName || ""));
    }

    setIsLoading(false);
  };

  return (
    <div className="accordion-item border-0 m-3">
      <p className="accordion-header" id="headingOne">
        <button
          className="accordion-button p-3 px-4 rounded-pill shadow-none setting-header border border-green-200"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          aria-expanded={expanded}
          aria-controls="collapseOne"
        >
          Account Settings &nbsp;{" "}
          <small className="small-text">
            (Change your personal information)
          </small>
        </button>
      </p>
      <div
        id="collapseOne"
        className={`accordion-collapse collapse ${expanded ? "show" : "hide"}`}
        aria-labelledby="headingOne"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body border-bottom border-start border-end border-1 rounded setting-box">
          {isValidating ? (
            <div className="mb-5 pb-5">
              <SpinLoader />
            </div>
          ) : (
            <Form
              className="row"
              onSubmit={handleSubmit}
              onChange={handleChange}
              onError={setFormError}
              formValue={formData}
              fluid
            >
              <div className="p-3 border-bottom">
                <div className="row">
                  <TextInput name="FirstName">First Name</TextInput>
                  <TextInput name="LastName">Last Name</TextInput>
                </div>
                <div className="row">
                  <TextInput name="PhoneNumber">Phone Number</TextInput>
                </div>

                <div className="row">
                  <FileInput
                    listType="picture"
                    imageSrc={imageUploadLogo}
                    name="ProfilePic"
                    accept="image/*"
                    imageSrcApi={
                      data?.profilePic
                        ? AppRouteApi.Media.ByPath(data.profilePic)
                        : imageUploadLogo
                    }
                  >
                    Profile Picture
                  </FileInput>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  className="px-5 mt-3 btn-green"
                  type="submit"
                  name="Update"
                  loading={!!isLoading}
                  disabled={isDisabled}
                />
              </div>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};
